const searchModule = {
  state: {
    searchParams: null,
    newBookingData: null,
    additionalFreeTour: null,
  },

  mutations: {
    SET_SEARCH_PARAMS(state, searchParams) {
      state.searchParams = searchParams;
    },
    SET_NEW_BOOKING_DATA(state, newBookingData) {
      state.newBookingData = newBookingData;
    },
    REMOVE_NEW_BOOKING_DATA(state) {
      state.newBookingData = null;
    },
    SET_FREE_TOUR(state, tour) {
      state.additionalFreeTour = tour;
    },
  },

  actions: {
    setSearchParams(context, searchParams) {
      context.commit('SET_SEARCH_PARAMS', searchParams);
    },
    setNewBookingData(context, newBookingData) {
      context.commit('SET_NEW_BOOKING_DATA', newBookingData);
    },
    removeNewBookingData(context) {
      context.commit('REMOVE_NEW_BOOKING_DATA');
    },
    setAdditionalFreeTour(context, freeTour) {
      context.commit('SET_FREE_TOUR', freeTour);
    },
  },
};

export default searchModule;
